import React, { Fragment, useState, useEffect } from 'react';
import {
    Card,
    CardBody,
    Container
} from "reactstrap";
import {
    DropdownToggle, DropdownMenu,
    UncontrolledButtonDropdown,
    DropdownItem
} from 'reactstrap';
import { Col, Row } from "react-bootstrap";

import GridLayout from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

import GraphChart from './Charts';
import { randstr } from '../../Common/Appcommon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import requestApi from "../../services/requestApi.service";

const GraphDashboard = (props) => {
    let { dashboard, isNeedRefresh, editChartConfig, cloneChartConfig, deletePrimaryChart, user, isDraggable, updateLayoutData, layoutInfo,isCanceled } = props;
    let [layoutData, setLayoutData] = useState([]);
    let [initialLayoutData, setInitialLayoutData] = useState([]);
    let [layoutNameKey, setLayoutNameKey] = useState({});

    useEffect(() => {
        (async () => {
            if (dashboard.length > 0) {
                await constructLayoutData(dashboard);
            }
        })();
        return () => {

        };

    }, [dashboard]);

    useEffect(() => {
        if (isCanceled) {
            setLayoutData(initialLayoutData); 
            updateLayoutData(initialLayoutData);
        }
    }, [isCanceled]);

    const constructLayoutData = async (dInfo) => {
        let layout = [];
        let keymap = {};
        if (layoutInfo === "" || layoutInfo === "null" || layoutInfo === undefined || layoutInfo === null) {
            let indexvalue = 0;
            let rowvalue = 0;
            dInfo.map((data, index) => {
                let dashboardid = data[0];
                let name = data[1];
                let xvalue = indexvalue * 6;
                if (xvalue > 10) {
                    xvalue = 0;
                    indexvalue = 0;
                    rowvalue = rowvalue + 1;
                }
                indexvalue = indexvalue + 1;
                let key = randstr("graph_") + "##" + name + "_" + dashboardid;
                key = key.replaceAll(" ", "_");
                keymap[name + "_" + dashboardid] = key;
                let tmplayout = { i: key, x: xvalue, y: rowvalue, w: 6, h: 2.88, isResizable: false };
                layout.push(tmplayout);
            });
        } else {
            //layoutInfo = JSON.parse(layoutInfo);
            if (layoutInfo.length > 0) {
                layoutInfo.map((data, index) => {
                    let ddata = dInfo[index];
                    let layoutkey = data['i'];
                    let dashboardid = ddata[0];
                    let name = ddata[1];
                    if (layoutkey !== undefined && name !== undefined && dashboardid !== undefined) {
                        keymap[name+"_"+dashboardid] = layoutkey;
                    }
                });
                layout = layoutInfo;
            }
        }
        setLayoutNameKey(keymap);
        setLayoutData(layout);
        setInitialLayoutData(layout);
        updateLayoutData(layout);
    }

    const handleLayoutChange = async (layout) => {
        setLayoutData(layout); 
        updateLayoutData(layout);
    }

    const openMoreChartData = async (e, chartId) => {
        window.open(
            "#/crmsearch",
            '_self' // <- This is what makes it open in a new window.
        );
        let timeout = 3000;
        let params = {
            "ENTITY": "DashBoard",
            "OPERATION": "FETCH_NEW_GRAPH_DB_DETAILS",
            "chartId": chartId,
            "ISREARRAGE": true
        }
        let res = await requestApi.processServerRequest(params);
        if (res.issuccess) {
            let ddata = res.data;
            if (ddata.length > 0) {
                let formname = ddata[0]['f1formname'];
                let condition = ddata[0]['data_condition'];
                setTimeout(() => {
                    let iframe = document.getElementById('cloned_iframe');
                    if (iframe != null) {
                        condition = condition.replaceAll("|", "empty");
                        let msgData = "primarydashboardsearch|" + formname + "|" + condition;
                        iframe.contentWindow.postMessage(msgData, "*");

                    }
                }, timeout);
            }
        }
    }
    return (
        <div className='primary-dashboard-container'>
            <div className='ml-1 mr-1'>
                {
                    dashboard.length > 0 &&
                    <Row className=''>
                        <GridLayout
                            className="layout"
                            layout={layoutData}
                            cols={12}
                            width={1200}
                            onLayoutChange={handleLayoutChange}
                            isDraggable={isDraggable}
                        >
                            {dashboard.map((item, index) => {
                                let condition = item[5];
                                let chartId = item[0];
                                let name = item[1];
                                let chartType = item[6];
                                let layoutKey = layoutNameKey[name + "_" + chartId];
                                return (
                                    <div key={layoutKey} md="2" className={`mb-1 grid-item `}>
                                        <Card className={'graphical-dashboard graph-dashboard-height'}>
                                            <CardBody>
                                                <Fragment>
                                                    <UncontrolledButtonDropdown className='graph-dashboard-component'>
                                                        <DropdownToggle color="link" className="p-0" >
                                                            <div className='cursor-pointer pd-more-settings'>
                                                                <span className='pd-chart-settings'>
                                                                    <FontAwesomeIcon className='fa-icon' icon={faEllipsisVertical} />
                                                                </span>
                                                            </div>
                                                        </DropdownToggle>
                                                        <DropdownMenu end className="rm-pointers dropdown-menu-md">
                                                            <DropdownItem key={randstr("edit_")} onClick={(e) => { openMoreChartData(e, chartId) }} >
                                                                <span className='ml-1'>More</span>
                                                            </DropdownItem>
                                                            <DropdownItem key={randstr("edit_")} onClick={(e) => { editChartConfig(e, chartId, chartType) }} >
                                                                <span className='ml-1'>Edit</span>
                                                            </DropdownItem>
                                                            <DropdownItem key={randstr("edit_")} onClick={(e) => { cloneChartConfig(e, chartId, chartType) }} >
                                                                <span className='ml-1'>Clone</span>
                                                            </DropdownItem>
                                                            <DropdownItem key={randstr("delete_")} onClick={(e) => { deletePrimaryChart(e, chartId) }}>
                                                                <span className='ml-1'>Delete</span>
                                                            </DropdownItem>
                                                        </DropdownMenu>
                                                    </UncontrolledButtonDropdown>
                                                </Fragment>
                                                <GraphChart user={user} isNeedRefresh={isNeedRefresh} key={randstr('gp_')} dashboard={item} />
                                            </CardBody>
                                        </Card>
                                    </div>
                                )
                            })}
                        </GridLayout>
                    </Row>

                }
            </div>
        </div>
    );
};

export default React.memo(GraphDashboard);